import React, {useEffect, useState} from 'react';
import styled from "styled-components"
import {
  useWindowHeight,
} from '@react-hook/window-size'
import { useMediaQuery } from 'react-responsive';
import './App.css';
//components
import Header from './MainComponents/Header';
import Start from './MainComponents/Start';
import GoogleAdvertise from './AdSence';

const Styled = {
  MobileWrap:styled.div`
    width:100%;
    height:auto;
    display:flex;
    justify-content: center;
    align-items: center;
    background-color: aquamarine;
    flex-direction: column;
  `,
  Mobiles:styled.div`
    width:100%;
    height: auto;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  `,
  Wrap:styled.div`
    width:80%;
    height: auto;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  `,
  Adsence:styled.div`
    width:20%;
    height:auto;
  `,
  AdsenceMobile:styled.div`
    width:100%;
    height:50px;
  `,
}


function App() {
  const onlyHeight = useWindowHeight()
  const [Product, setProduct] = useState<number>()
  const isMoblie = useMediaQuery({minWidth: 400})
  const isTablet = useMediaQuery({minWidth: 700})
  const isPC = useMediaQuery({minWidth:1080})
  useEffect(()=>{
    if(isPC === true){
      console.log("PC")
      setProduct(1080)
    } else if(isTablet === true){
      console.log("Tablet")
      setProduct(700)
    } else if(isMoblie === true){
      console.log("Mobile")
      setProduct(400)
    }
  },[isMoblie, isTablet, isPC])

  const MainBox = styled.div`
    width:${Product}px;
    height: ${onlyHeight +0.5}px;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    background-color: beige;
    flex-direction: column;
    min-width:${Product}px;
  `  
  if(isMoblie === true){
    return(
      <Styled.Mobiles>
        <MainBox>
          <Header />
          <Start />
        </MainBox>
      </Styled.Mobiles>
  )
  }else{
    return (
      <Styled.Wrap>
        <Styled.Adsence>
          <GoogleAdvertise
            client="ca-pub-1195209293008237"
            slot="3954159514"
            format="fluid"
            responsive="true"
            layoutKey="-fz+6a+19-cg+hh"
          />
        </Styled.Adsence>
        <MainBox>
          <Header />
          <Start />
        </MainBox>
      </Styled.Wrap>
  );
  }
}

export default App;
